import { addIcons } from 'ionicons';
import * as allIcons from 'ionicons/icons';

export function registerIonicons(): void {
  addIcons(allIcons);
}
